import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './styles/message-rendered.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import router from './router'
import { installConsolePolicy } from './utils/logger'

installConsolePolicy()

// 【TDZ 调试】全局捕获未处理错误,记录 ReferenceError / TypeError 等
//  生产环境下同样生效。错误会带上完整堆栈、来源URL、行/列。
//  例如 "Cannot access 'fe' before initialization" (TDZ) 可在控制台看到
//  完整的 stack,辅助定位是哪个 chunk / 文件引起的。
if (typeof window !== 'undefined') {
  const describeError = (label, err, source, lineno, colno) => {
    const name = err?.name || 'Error'
    const msg = err?.message || String(err)
    const stack = err?.stack || '(no stack)'
    console.group(`%c[GlobalError][${label}] ${name}: ${msg}`, 'color:#dc2626;font-weight:600')
    console.error('  source:', source, `@${lineno}:${colno}`)
    console.error('  stack:', stack)
    if (err && typeof err === 'object') {
      console.error('  full error object:', err)
    }
    console.groupEnd()
  }

  window.addEventListener('error', (event) => {
    describeError('window.error', event.error || event.message, event.filename, event.lineno, event.colno)
  }, { capture: true })

  window.addEventListener('unhandledrejection', (event) => {
    describeError('unhandledrejection', event.reason, '(promise)', 0, 0)
  }, { capture: true })

  // 【可选】vue 运行时错误钩子,在 app.config.errorHandler 中可以拿到的信息
  //  这里放在 createApp 之后,下面会使用 app.config.errorHandler。
}

const app = createApp(App)

// 【TDZ 调试】Vue 运行时错误捕获,会在 setup / render / watch 报错时调用
app.config.errorHandler = (err, instance, info) => {
  const componentName = instance?.$options?.name || instance?.type?.__name || '(unknown)'
  console.group(`%c[VueError] in ${componentName} [${info}]`, 'color:#dc2626;font-weight:600')
  console.error('  message:', err?.message)
  console.error('  stack:', err?.stack)
  console.groupEnd()
}

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(createPinia())
app.use(router)
app.use(ElementPlus)
app.mount('#app')
